import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import BundleCard from "./BundleCard";
import { useTheme } from "../../context/ThemeContext";
import { bgWithImageStyle, sectionBgColor } from "../../utils/themeBg";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BundleSection = ({ products = [] }) => {
  const [bundles, setBundles] = useState([]);
  const { settings } = useTheme();

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/bundles`);
        if (alive) setBundles(data || []);
      } catch {
        if (alive) setBundles([]);
      }
    })();
    return () => { alive = false; };
  }, []);

  if (bundles.length === 0 || products.length === 0) return null;

  const productsById = {};
  products.forEach((p) => { productsById[p.id] = p; });

  const bundleSection = {
    label: "Kit & Bundle",
    title: "Pacchetti pensati per il tuo obiettivo",
    subtitle: "Combinazioni selezionate dal nostro team, a un prezzo speciale.",
    ...(settings?.bundle_section || {}),
  };

  return (
    <section className="lv-section lv-section-kit py-20 md:py-24 border-y border-white/5" style={bgWithImageStyle(sectionBgColor(settings, "bundle"))} data-testid="bundle-section" id="kit">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-10 max-w-2xl"
        >
          <span className="text-[11px] tracking-[0.4em] uppercase text-[#C0C0C0]" data-testid="bundle-section-label">{bundleSection.label}</span>
          <h2 className="mt-4 font-[Outfit] text-white font-light tracking-tight" style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }} data-testid="bundle-section-title">
            {bundleSection.title}
          </h2>
          <p className="mt-3 text-[#94A3B8] text-sm sm:text-base" data-testid="bundle-section-subtitle">
            {bundleSection.subtitle}
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="bundle-grid">
          {bundles.map((b) => <BundleCard key={b.id} bundle={b} productsById={productsById} />)}
        </div>
      </div>
    </section>
  );
};

export default BundleSection;
